import "./lib/zod-jitless";
import "@fontsource-variable/dm-sans";
// Used by document themes, which name the family; the app chrome does not use it.
import "@fontsource/dm-serif-display/400.css";
import "@fontsource/dm-mono/400.css";
import "@fontsource/dm-mono/500.css";
import "./styles/app.css";
import "./styles/prosemirror.css";
import "./styles/canvas.css";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "@tanstack/react-router";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { createAppRouter } from "./app/router";
import { setUnauthorizedHandler } from "./lib/api/client";

const queryClient = new QueryClient({
  defaultOptions: { queries: { staleTime: 30_000, retry: (n, e) => n < 2 && !(e instanceof Error && "status" in e) } },
});
const router = createAppRouter(queryClient);

setUnauthorizedHandler(() => {
  queryClient.clear();
  const here = window.location.pathname + window.location.search;
  if (!here.startsWith("/signin")) void router.navigate({ to: "/signin", search: { returnTo: here } });
});

const el = document.getElementById("root");
if (!el) throw new Error("#root missing");
createRoot(el).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  </StrictMode>,
);
